export class CacheStorage {
  constructor(storage, name) {
    this.storage = storage;
    this.name = name;
  }

  getKey(key) {
    return `${this.name}_${key}`;
  }

  get(name) {
    return this.storage.getItem(this.getKey(name));
  }

  set(name) {
    return this.storage.setItem(this.getKey(name));
  }

  remove(name) {
    return this.storage.removeItem(this.getKey(name));
  }
}
